import React, { useState } from 'react';
import { Button } from '@peoplegrove/pg-components';
import classes from './ConversationSnapshots.module.scss';
import ManageTagsModal from '../../../SupportChatModuleTags/ManageTagsModal';

const Heading = () => {
  const [showManageTagsModal, setShowManageTagsModal] = useState(false);
  return (
    <div className={classes.headerRow}>
      <div className={classes.headerRowLeft}>
        <h2 className={classes.heading} id="conversation-snapshot-heading">
          Conversation Snapshot
        </h2>
      </div>
      <div className={classes.headerRowRight}>
        <Button
          key="manage-tags"
          type="link"
          onClick={() => setShowManageTagsModal(true)}
        >
          Manage Tags
        </Button>
        <Button
          key="help-articles"
          type="link"
          onClick={() => {
            window.open('https://peoplegrove.zendesk.com/hc/en-us', '_blank');
          }}
        >
          Help Articles
        </Button>
      </div>
      {showManageTagsModal && (
        <ManageTagsModal
          visible={showManageTagsModal}
          onCancel={() => setShowManageTagsModal(false)}
        />
      )}
    </div>
  );
};

export default Heading;
